import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class HomeService {

    menuChange: Subject<Object> = new Subject<Object>();
}
